import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const STATS = [
  { value: 500, suffix: "K+", label: "Branded Cups Printed", bg: "bg-[#FF5A36]", text: "text-white" },
  { value: 1200, suffix: "+", label: "Chai Tapri & Café Partners", bg: "bg-[#FBBF24]", text: "text-[#2E1065]" },
  { value: 35, suffix: " min", label: "Avg. Exposure per Cup", bg: "bg-[#0D9488]", text: "text-white" },
  { value: 15, suffix: " days", label: "Delivery Across India", bg: "bg-[#2E1065]", text: "text-[#FBBF24]" },
];

const Counter = ({ target, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const dur = 1600;
    let raf;
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(target * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, target]);

  return (
    <span ref={ref} className="font-display font-black text-4xl sm:text-5xl">
      {new Intl.NumberFormat("en-US").format(val)}{suffix}
    </span>
  );
};

export const StatsStrip = () => (
  <section className="py-16 sm:py-20" data-testid="stats-strip">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-2 lg:grid-cols-4 gap-4">
      {STATS.map((s, i) => (
        <motion.div
          key={s.label}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
          className={`${s.bg} ${s.text} rounded-3xl p-7 sm:p-8 hover:-translate-y-1.5 hover:rotate-1 transition-all duration-300`}
          data-testid={`stat-card-${i}`}
        >
          <Counter target={s.value} suffix={s.suffix} />
          <p className="mt-2 text-sm font-bold opacity-80">{s.label}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
